import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
const SecureStorage = require('secure-web-storage');
const SECRET_KEY: any = 'Y7J82,Lf^KwM@v?&X&q3bcF';
declare var require: any;

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor() {}

  secureStorage = new SecureStorage(sessionStorage, {
    hash: function hash(key: any) {
      key = CryptoJS.SHA256(key, SECRET_KEY);
      return key.toString();
    }, 
     
    // Encrypt the localstorage data
    encrypt: function encrypt(data: any) {
      data = CryptoJS.AES.encrypt(data, SECRET_KEY);
      data = data.toString();
      return data;
    },

    // Decrypt the encrypted data
    decrypt: function decrypt(data: any) {
      data = CryptoJS.AES.decrypt(data, SECRET_KEY);
      data = data.toString(CryptoJS.enc.Utf8);
      return data;
    },
  });

  SecureStorage2 = new SecureStorage(localStorage, {
    hash: function hash(key: any) {
      key = CryptoJS.SHA256(key, SECRET_KEY);
      return key.toString();
    }, 
     
    // Encrypt the localstorage data
    encrypt: function encrypt(data: any) {
      data = CryptoJS.AES.encrypt(data, SECRET_KEY);
      data = data.toString();
      return data;
    },

    // Decrypt the encrypted data
    decrypt: function decrypt(data: any) {
      data = CryptoJS.AES.decrypt(data, SECRET_KEY);
      data = data.toString(CryptoJS.enc.Utf8);
      return data;
    },
  });

  public setuser(data: any) {
  return this.SecureStorage2.setItem('userData', data);
}

public getuserData(): any {
  return this.SecureStorage2.getItem('userData');
}

public hasValidMobile(): boolean {
  const user = this.getuserData();
  return user?.phoneNumbers?.some(
    (p: any) => p?.phoneNumber && p.phoneNumber.trim() !== ''
  );
}

  public setRoles(roles: []) {
    return this.secureStorage.setItem('roles', roles);
  }

  public getRoles() {
    return this.secureStorage.getItem('roles');
  }

  public setToken(jwtToken: any) {
    return this.secureStorage.setItem('jwtToken', jwtToken);
  }

  public getToken(): string {
    return this.secureStorage.getItem('jwtToken');
  }

  public setJobs(data: any) {
    return this.secureStorage.setItem('job', data);
  }

  public getJobs(): string {
    return this.secureStorage.getItem('job');
  }

  public getuser(): string {
    return this.secureStorage.getItem('username');
  }

  public setusername(username: any) {
    return this.secureStorage.setItem('username', username);
  }

  public getemail(): string {
    return this.SecureStorage2.getItem('email');
  }

  public setuseremail(username: any) {
    return this.SecureStorage2.setItem('email', username);
  }

  public getlocation(): string {
    return this.secureStorage.getItem('location');
  }

  public setlocation(username: any) {
    return this.secureStorage.setItem('location', username);
  }

  public getcurrency(): string {
    return this.secureStorage.getItem('currency');
  }

  public setcurrency(username: any) {
    return this.secureStorage.setItem('currency', username);
  }

  public clear() {
    return this.secureStorage.clear();
  }

  public variable(data: any) {
    return this.secureStorage.setItem('alldata', data);
  }

  public getvariable(): string {
    return this.secureStorage.getItem('alldata');
  }

  public isLoggedIn() {
    return this.getRoles() && this.getToken() && this.getuser();
  }
}
